import { render, staticRenderFns } from "./WesternMedicineCdss.vue?vue&type=template&id=2a1d050c&scoped=true&"
import script from "./WesternMedicineCdss.vue?vue&type=script&lang=js&"
export * from "./WesternMedicineCdss.vue?vue&type=script&lang=js&"
import style0 from "./WesternMedicineCdss.vue?vue&type=style&index=0&id=2a1d050c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d050c",
  null
  
)

export default component.exports